(function() {
  function initPredictiveSearch() {
    var searchBars = document.querySelectorAll('.sc-search-bar');
    searchBars.forEach(function(bar) {
      var input = bar.querySelector('.sc-search-input');
      var results = bar.querySelector('.sc-search-results');
      if (!input || !results) return;
      if (input.dataset.scInit) return;
      input.dataset.scInit = 'true';

      var timer = null;

      input.addEventListener('input', function(e) {
        e.stopPropagation();
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) {
          results.classList.remove('active');
          results.innerHTML = '';
          return;
        }

        timer = setTimeout(function() {
          var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
          var xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.onload = function() {
            if (xhr.status === 200) {
              try {
                var data = JSON.parse(xhr.responseText);
                var products = data.resources.results.products || [];
                if (products.length === 0) {
                  results.innerHTML = '<div class="sc-search-no-results">No se encontraron productos</div>';
                } else {
                  var html = '';
                  for (var i = 0; i < products.length; i++) {
                    var p = products[i];
                    var imgHtml = p.image ? '<img src="' + p.image + '" alt="">' : '';
                    var priceNum = Math.round(parseFloat(p.price));
                    var price = '$' + priceNum.toLocaleString('es-CL');
                    html += '<a href="' + p.url + '" class="sc-search-result">';
                    html += imgHtml;
                    html += '<div class="sc-search-result-info">';
                    html += '<span class="sc-search-result-title">' + p.title + '</span>';
                    html += '<span class="sc-search-result-price">' + price + '</span>';
                    html += '</div></a>';
                  }
                  html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="sc-search-all">Ver todos los resultados</a>';
                  results.innerHTML = html;
                }
                results.classList.add('active');
              } catch(e) {
                results.classList.remove('active');
              }
            }
          };
          xhr.send();
        }, 300);
      });

      input.addEventListener('focus', function() {
        if (input.value.trim().length >= 2 && results.innerHTML.length > 0) {
          results.classList.add('active');
        }
      });

      document.addEventListener('click', function(e) {
        if (!bar.contains(e.target)) {
          results.classList.remove('active');
        }
      });

      input.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          results.classList.remove('active');
          input.blur();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(initPredictiveSearch, 500); });
  } else {
    setTimeout(initPredictiveSearch, 500);
  }
})();